import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMoveWiggle12 from './IconMoveWiggle12';
import IconMoveWiggle16 from './IconMoveWiggle16';
import IconMoveWiggle20 from './IconMoveWiggle20';
import IconMoveWiggle24 from './IconMoveWiggle24';
import IconMoveWiggle32 from './IconMoveWiggle32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMoveWiggle = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMoveWiggle12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMoveWiggle16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMoveWiggle20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMoveWiggle24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMoveWiggle32 {...props} />}
        </span>
    );
};
IconMoveWiggle.displayName = 'FondueIconMoveWiggle';

export default memo(IconMoveWiggle);
